<template>
    <div>
        <v-row>
            <v-col sm="12" md="6">
                <v-card>
                    <v-card-text>
                        <v-skeleton-loader
                            class="mb-2"
                            type="heading"
                        ></v-skeleton-loader>
                        <v-skeleton-loader
                            class="mb-2"
                            type="image"
                        ></v-skeleton-loader>
                        <v-skeleton-loader
                            class="mb-2"
                            type="paragraph"
                        ></v-skeleton-loader>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col sm="12" md="6">
                <v-card>
                    <v-card-text>
                        <v-skeleton-loader
                            class="mb-2"
                            type="heading"
                        ></v-skeleton-loader>
                        <v-skeleton-loader
                            class="mb-2"
                            type="image"
                        ></v-skeleton-loader>
                        <v-skeleton-loader
                            class="mb-2"
                            type="paragraph"
                        ></v-skeleton-loader>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col sm="12" md="6">
                <v-card>
                    <v-card-text>
                        <v-skeleton-loader
                            class="mb-2"
                            type="heading"
                        ></v-skeleton-loader>
                        <v-skeleton-loader
                            class="mb-2"
                            type="image"
                        ></v-skeleton-loader>
                        <v-skeleton-loader
                            class="mb-2"
                            type="paragraph"
                        ></v-skeleton-loader>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col sm="12" md="6">
                <v-card>
                    <v-card-text>
                        <v-skeleton-loader
                            class="mb-2"
                            type="heading"
                        ></v-skeleton-loader>
                        <v-skeleton-loader
                            class="mb-2"
                            type="image"
                        ></v-skeleton-loader>
                        <v-skeleton-loader
                            class="mb-2"
                            type="paragraph"
                        ></v-skeleton-loader>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    export default{
        data() {
            return {
                
            }
        }
    }
</script>
